import type { ApiError } from "@touchscreen/api-client";

/**
 * Copy for every documented `POST /requests` error, shared so both surfaces say the same thing.
 * None of these accuse the punter — a stale search result or a shared venue window are expected
 * outcomes, not client bugs. See touchscreen-api.md §POST /requests and
 * touchscreen-frontend.md §Requests.
 */
export function requestErrorMessage(error: ApiError): string {
  switch (error.code) {
    case "requests_closed":
      return "Requests are closed right now";
    case "player_offline":
      return "The music system here isn't responding right now";
    case "outside_geofence":
      return "You need to be in the venue to request";
    case "position_required":
      return "We need your location to request here";
    case "track_unavailable":
      return "That track isn't available here anymore";
    case "track_cooldown":
      return "That track was requested too recently — try again later";
    case "requester_limit":
      return "You've used up your requests for this hour";
    case "venue_limit":
      return "This screen has reached its request limit for now";
    case "token_invalid":
    case "token_expired":
      return "Your session needs to be refreshed — try again";
    case "network_error":
      return "Couldn't reach the network — check the connection and try again";
    default:
      return "Something went wrong — try again";
  }
}
